import {IonIcon, IonItem, IonLabel} from '@ionic/react'
import { ModalTemplate } from '../../../../components'
import React, {useEffect, useState} from "react"
import styles from './styles.module.scss'
import {formatLongDate} from "../../../../utils/helpers/date";
import {Browser} from "@capacitor/browser";
import {faFilePdf, faFile} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Capacitor} from "@capacitor/core"
import {PushNotifications} from "@capacitor/push-notifications"
import {startSpeaking, stopSpeaking} from '../../../../utils/functions/speak'
import {micOutline, stopCircleOutline} from "ionicons/icons"
import {openForm} from '../../../../utils/functions/forms'

export const NotificationItem = ({
                                   close,
                                   notification,
                                   userId,
                                   markAsRead,
                                   textToSpeechEnabled,
                                   router,
                                }) => {

  const [speaking, setSpeaking] = useState(false)

  const speak = async (text) => {
    if (!textToSpeechEnabled) return

    if (speaking){
      await stopSpeaking()
      setSpeaking(false)
    }
    else{
      setSpeaking(true)
      await startSpeaking(text)
      setSpeaking(false)
    }
  }

  useEffect(() => {
    if(Capacitor.getPlatform() === 'ios'){
      // This will clear the badge number on ios
      PushNotifications.removeAllDeliveredNotifications()
    }
  }, [])

  useEffect(() => {
    // console.log(notification?.read)
    if (notification && !notification?.read) {
      markAsRead(userId, notification.notification_id)
    }
  }, [notification, userId, markAsRead])

  const openPdf = async (url) => {
    await Browser.open({
      url: url,
      windowName: '_self'
    });
  }

  return (
    <ModalTemplate isOpen={Boolean(notification)}
                   title='Notification'
                   closeMethod={() => {close()}}
                   parent={router}>


        <h1 className={`${textToSpeechEnabled ? styles.speech_enabled : ''}`}>
          {notification?.notification_title}
        </h1>

        {textToSpeechEnabled &&
          <p>
            <IonIcon onClick={() => speak(notification?.notification_title)}
                     className={`${speaking ? styles.speech_started : ''}`}
                     icon={speaking ? stopCircleOutline : micOutline} />
          </p>
        }

      <p>{formatLongDate(notification?.date)}</p>

      {
        notification?.image &&
        <img src={notification.image} className={styles.avatar_img} alt='' />
      }

      <div onClick={() => speak(notification?.notification_content_spoken)}
           dangerouslySetInnerHTML={{__html: notification?.notification_content}} />

      {
        textToSpeechEnabled &&
        <p onClick={() => speak(notification?.notification_content_spoken)}
           className={styles.speech_enabled}>
          <IonIcon className={`${speaking ? styles.speech_started : ''}`} icon={speaking ? stopCircleOutline : micOutline} />
        </p>
      }

      {
        notification?.field_link_to_form &&
        <IonItem button detail onClick={() => openForm(notification.field_link_to_form)}>
          <FontAwesomeIcon icon={faFile} className={styles.pdf_icon} />
          <IonLabel>
            Open form
          </IonLabel>
        </IonItem>
      }

      {
        notification?.pdf &&
        <IonItem button onClick={() => {
          openPdf(JSON.parse(localStorage.getItem('organisation_details'))?.url + notification.pdf)
        }} detail>
          <FontAwesomeIcon icon={faFilePdf} className={styles.pdf_icon} />
          <IonLabel>
            View attachment
          </IonLabel>
        </IonItem>
      }

    </ModalTemplate>
  )
}